import { graphql } from '@/gql';
import type { CreatePartnerHoursMutation, CreatePartnerHoursMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type CreatePartnerHoursInput = CreatePartnerHoursMutationVariables;

export type CreatePartnerHoursOutput = CreatePartnerHoursMutation['createPartnerHours'];

export const createPartnerHours = async ({ data, partnerId }: CreatePartnerHoursInput): Promise<CreatePartnerHoursOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreatePartnerHours($partnerId: Float!, $data: [PartnerHourInputType!]!) {
        createPartnerHours(partnerId: $partnerId, data: $data) {
          day
          partnerId
          start
          end
        }
      }
    `),
    variables: {
      partnerId,
      data,
    },
  });

  return response.data!.createPartnerHours;
};
